import { create } from 'zustand';

export type SidePanelMode = 'not-set' | 'ai-suggest-risk-controls' | 'ai-chat';

export interface SidePanelState {
  isOpen: boolean;
  mode: SidePanelMode;
  isWidePanel: boolean;
  openFor: (
    mode: SidePanelMode,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onActionCompleted?: () => void | Promise<any>
  ) => void;
  close: () => void;
  locationChanged: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onActionCompleted?: () => void | Promise<any>;
}

// Add modes that need a wider panel to this set
const widePanelSet = new Set<SidePanelMode>([
  'ai-suggest-risk-controls',
  'ai-chat',
]);

export const useSidePanelStore = create<SidePanelState>((set) => ({
  isOpen: false,
  mode: 'not-set',
  isWidePanel: false,
  onActionCompleted: undefined,
  openFor: (
    mode: SidePanelMode,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onActionCompleted?: () => void | Promise<any>
  ) => {
    set(() => ({
      mode,
      isOpen: true,
      isWidePanel: widePanelSet.has(mode),
      onActionCompleted,
    }));
  },
  close: () => {
    set(() => ({
      isOpen: false,
    }));
  },
  locationChanged: () => {
    set((state) => {
      return {
        isOpen: state.isOpen && state.mode === 'ai-chat',
      };
    });
  },
}));
